import React, { Fragment } from 'react';

export class Home extends React.Component {
  render() {
    return (
      <Fragment>
        <h1>Welcome to the Home page</h1>
      </Fragment>
    );
  }
}
